import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMenuItems } from "../../../api/menu";

export const fetchMenu = createAsyncThunk('user/getMenu', async () => {
    const response = await getMenuItems()
    // console.log("fetchMenu", response)
    return response
})

export const menuSlice = createSlice({
    name: "user/getMenu",
    initialState: {
        loading: false,
        menuData: []
    },
    reducer: {},
    extraReducers: (builder) => {

        builder.addCase(
            fetchMenu.fulfilled, (state, action) => {
                state.loading = false
                state.menuData = action.payload.data
            }
        )
        .addCase(
            fetchMenu.pending, (state, action) => {
                state.loading = true
            }
        )
        .addCase(
            fetchMenu.rejected, (state, action) => {
                state.loading = false
            }
        )
    }
})

export default menuSlice.reducer